// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import Icon from 'Components/Icon';
import classNames from 'classnames/bind';
import FlyoutLink from './link';
import FlyoutTeaser from './teaser';
import Button from 'Components/Button';
import styles from './styles.scss';
import hstyles from '../styles.scss';
import { getTabByHref } from 'Utils/getContactTab';
import { MODAL_TYPES } from 'Containers/ContactForm/contactFormConstants';

const cx = classNames.bind(styles);
const cxh = classNames.bind(hstyles);

const matchMedia = window.matchMedia('(max-width: 768px)');

type Props = {
  id: String,
  entry: Object,
  open: boolean,
  history: Object,
  onLinkClick: (entry: Object) => void,
  onMainEntryClick: (entry: Object) => void,
  transitionDelay: boolean,
  children: Node,
  isServicePartnerOnly: boolean,
  isSalesPartnerOnly: boolean,
  isOsbUser: boolean,
  forceMobileMenu: boolean,
  ariaLabelledby: string,
};

class Flyout extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.state = {
      hide: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      if (this.props.open) {
        this.setState({ hide: false });

        if (matchMedia.matches) {
          setTimeout(() => {
            const firstFocusableElement = document.querySelector(`#${this.props.id} button`);
            firstFocusableElement.focus();
          }, 300);
        }
      } else {
        setTimeout(() => {
          this.setState({ hide: true });
        }, 300);
      }
    }
  }

  componentDidMount() {
    document.body.addEventListener('click', this.handleBodyClick);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleBodyClick);
  }

  handleBodyClick = (event) => {
    if (
      !event.target.closest('.' + cx('header__flyout')) &&
      !event.target.closest('.' + cxh('main-nav__item')) &&
      !event.target.closest('.' + cxh('mobile-burger'))
    ) {
      this.handleExternalInteraction();
    }
  };

  handleKeyDown = (event) => {
    const pressedKey = event.key;

    if (pressedKey === 'Escape' && this.props.open) {
      this.handleExternalInteraction();
      event.preventDefault();
    }
  };

  handleExternalInteraction = () => {
    if (this.props.open) {
      this.handleMainEntryClick();
    }
  };

  handleLinkClick = (lvl3) => {
    const tab = getTabByHref(lvl3.path);

    if (lvl3 && lvl3.label === 'Unsere Standorte') {
      this.handleMainEntryClick();
    }

    if (tab === 1) {
      this.props.onLinkClick(this.props.entry);
      return this.props.updateMultipleUrlQuery({
        modaltype: MODAL_TYPES.SERVICE_APPOINTMENT.name,
        showmodal: 'true',
      });
    }

    if (tab === 3) {
      this.props.onLinkClick(this.props.entry);
      return this.props.updateMultipleUrlQuery({
        modaltype: MODAL_TYPES.REQUEST_FOR_CONSULTATION_FK.name,
        showmodal: 'true',
      });
    }

    if (tab > -1) {
      this.props.onLinkClick(this.props.entry);
      return this.props.onOpenContact(tab);
    }

    // temporary fmm fix
    if (
      !lvl3.path.startsWith('/beratung-und-kauf/fahrzeugboerse/neuwagen') &&
      !lvl3.path.startsWith('/beratung-und-kauf/fahrzeugboerse/gebraucht') &&
      !lvl3.path.startsWith('/beratung-und-kauf/weitere-leistungen/gebrauchtwagenbewertung') &&
      !lvl3.path.startsWith('/beratung-und-kauf/fahrzeugboerse/haendlerzulassung')
    ) {
      this.props.history.push(lvl3.path);
      this.props.onLinkClick(this.props.entry);

      return;
    }

    if (lvl3.path.endsWith('/haendlerzulassung/')) {
      window.location.href = window.location.protocol + '//' + window.location.host + lvl3.path;

      return;
    }

    // MAZ-531 do not call 301, redirect self
    if (lvl3.path.endsWith('/weitere-leistungen/gebrauchtwagenbewertung/')) {
      window.location.href =
        window.location.protocol + '//' + window.location.host + '/gebrauchtwagenbewertung/';

      return;
    }

    window.location.href = window.location.protocol + '//' + window.location.host + lvl3.path;
  };

  handleMainEntryClick = () => {
    // element in navigation level 1
    const focusableElement = document.querySelector(`[aria-controls="${this.props.id}"]`);

    if (focusableElement) {
      focusableElement.focus();
    }

    this.props.onMainEntryClick(this.props.entry);
  };

  render() {
    const {
      id,
      entry,
      open,
      transitionDelay,
      children,
      //isServicePartnerOnly,
      isSalesPartnerOnly,
      forceMobileMenu,
      ariaLabelledby,
    } = this.props;
    const dfmm = { 'data-force-mobile-menu': forceMobileMenu };

    let entriesLvl2 =
      entry.subentries.filter((subentry) => subentry.subentries && !!subentry.subentries.length) ||
      [];

    // if (isServicePartnerOnly) {
    //   entriesLvl2 = entriesLvl2.map(entry => {
    //     if (entry.label !== 'Termin vereinbaren') {
    //       return entry;
    //     }
    //
    //     let updatedEntry = { ...entry };
    //     updatedEntry.subentries = updatedEntry.subentries.filter(
    //       subentry => subentry.label !== 'Beratung'
    //     );
    //     return updatedEntry;
    //   });
    // }

    if (isSalesPartnerOnly) {
      entriesLvl2 = entriesLvl2.map((entry) => {
        if (entry.label !== 'Termin vereinbaren') {
          return entry;
        }

        let updatedEntry = { ...entry };
        updatedEntry.subentries = updatedEntry.subentries.filter(
          (subentry) => subentry.label !== 'Werkstatt'
        );
        return updatedEntry;
      });
    }

    const flyoutClass = cx('header__flyout', {
      'header__flyout--open': !this.state.hide && open,
      'header__flyout--transition-delay': transitionDelay,
      'header__flyout--no-teaser': !children,
    });

    return (
      <nav
        id={id}
        className={flyoutClass}
        hidden={!open && this.state.hide ? true : undefined}
        aria-labelledby={ariaLabelledby}
        onKeyDown={this.handleKeyDown}
        {...dfmm}
      >
        <div className={cx('relativeWrapper')} {...dfmm}>
          <div className={cx('gr-container')} {...dfmm}>
            <button
              className={cx('flyout-head')}
              aria-controls={id}
              aria-expanded={open}
              aria-label={entry.label}
              onClick={this.handleMainEntryClick}
              {...dfmm}
            >
              <Icon name="caret-left" className={styles.icon} inline={false} />
              <span>{entry.label}</span>
            </button>
            <ul className={cx('flyout-nav')} {...dfmm}>
              {entriesLvl2.map((lvl2, i) => {
                const entriesLvl3 = lvl2.subentries || [];

                if (
                  entriesLvl2.hideInMenu === true ||
                  entriesLvl3.every((item) => item.hideInMenu === true)
                ) {
                  return;
                }

                return (
                  <li key={`flyout-lvl2-${i}`} className={cx('flyout-nav__item')} {...dfmm}>
                    <h3 className={cx('flyout-nav__item-headline')} aria-label={lvl2.label}>
                      {lvl2.label}
                    </h3>
                    <ul className={cx('flyout-subnav')}>
                      {entriesLvl3.map((lvl3) => {
                        if (entry.hideInMenu === true) {
                          return;
                        }

                        return (
                          <FlyoutLink
                            key={lvl3.id}
                            entry={lvl3}
                            parentEntries={[entry, lvl2]}
                            onClick={this.handleLinkClick}
                          />
                        );
                      })}
                    </ul>
                  </li>
                );
              })}
            </ul>
            {children && (
              <FlyoutTeaser
                size={entriesLvl2.length > 2 ? 'small' : 'large'}
                forceMobileMenu={forceMobileMenu}
              >
                {children}
              </FlyoutTeaser>
            )}
          </div>
          <Button
            className={cx('closebtn')}
            variant="primary"
            icon="close"
            onClick={this.handleMainEntryClick}
            ariaExpanded={open === true}
            ariaControls={id}
            ariaLabel={`${open ? 'Schließe' : 'Öffne'} Untermenü`}
            additionalProps={dfmm}
          />
        </div>
      </nav>
    );
  }
}

export default withRouter(Flyout);
